export const amountRange = [
    {
        name: 'Fixed Amount',
        value: 'FIXED',
    },
    {
        name: 'Amount Range',
        value: 'VARIABLE',
    },
    {
        name: 'User Input',
        value: 'USER_INPUT',
    },

];
// export const userInput =['Mandatory', 'Optional'];
export const userInput = [
    {
        name: 'Mandatory',
        value: 'required',
    },
    {
        name: 'Optional',
        value: 'optional',
    },
];
// export const fieldType =['Mobile Num', ' Email Address', 'Name', 'Date'];
export const fieldType = [
    {
        name: 'Mobile Number',
        value: 'mobile',
    },
    {
        name: 'Email Address',
        value: 'email',
    },
    {
        name: 'Date',
        value: 'date',
    },
    {
        name: 'Name',
        value: 'name',
    },
    {
        name: 'Others',
        value: 'others',
    }
];

export const validityOptions = [
    {
        name: '1 Day',
        value: 1,
    },
    {
        name: '2 Days',
        value: 2,
    },
    {
        name: '3 Days',
        value: 3,
    },
    {
        name: '4 Days',
        value: 4,
    },
    {
        name: '5 Days',
        value: 5,
    },
    {
        name: '6 Days',
        value: 6,
    },
    {
        name: '7 Days',
        value: 7,
    },
    {
        name: '8 Days',
        value: 8,
    },
    {
        name: '9 Days',
        value: 9,
    },
    {
        name: '10 Days',
        value: 10,
    },
    {
        name: '11 Days',
        value: 11,
    },
    {
        name: '12 Days',
        value: 12,
    },
    {
        name: '13 Days',
        value: 13,
    },
    {
        name: '14 Days',
        value: 14,
    },
    {
        name: '15 Days',
        value: 15,
    },
];
